// Store
import { IResponseCollection } from '../interfaces/general.interfaces';
// import { IOrganisation } from '../interfaces/organisations.interfaces';
import { IAvailableSenderInformation, ISenderInfo, ISenderMessageCount } from '../interfaces/sender.interfaces';
import { getAvailableSenders } from '../services/sender.service';
import { SenderIdType } from '../enums';

export async function getSenders(mailboxId: string) {
    let senderInfoList: ISenderInfo[] = [];
    const availableSendersList = await getAvailableSenders(mailboxId).then(
        (availableSenders: IResponseCollection<IAvailableSenderInformation>) => {
            return availableSenders.items;
        }
    );
    senderInfoList = await resolveAvailableSenders(availableSendersList);
    //For the time being, I've commented on it for future reference.
    // const senderOrganisations = await getSenderOrganisations(getCVrNumbers(senderInfoList)).then(
    //     (senderOrganisations: IResponseCollection<IOrganisation>) => {
    //         return senderOrganisations.items;
    //     }
    // );
    // senderInfoList = await resolveSenderOrganisations(senderInfoList, senderOrganisations);
    senderInfoList = await resolveLogos(senderInfoList);
    return senderInfoList;
}

function resolveAvailableSenders(availableSendersList: IAvailableSenderInformation[]): Promise<ISenderInfo[]> {
    return Promise.all(
        availableSendersList
            .filter((senderInfo) => senderInfo.senderIdType === SenderIdType.Cvr)
            .map<ISenderInfo>((availableSender: IAvailableSenderInformation) => {
                return {
                    senderId: availableSender.senderId,
                    organisationId: availableSender.organisationId,
                    senderIdType: availableSender.senderIdType,
                    messageCountList: availableSender.messageCountList.map((messageCount: ISenderMessageCount) => {
                        return {
                            label: messageCount.label,
                            unreadMessages: messageCount.unreadMessages,
                            totalMessages: messageCount.totalMessages,
                            latestMessageFrom: messageCount.latestMessageFrom,
                        };
                    }),
                    name: null,
                    imageUrl: null,
                    id: null,
                    logoAvailable: false,
                    logoMimeType: null,
                };
            })
    );
}

//For the time being, I've commented on it for future reference.
// function getCVrNumbers(senderInfoList: ISenderInfo[]): string[] {
//     return senderInfoList.map((sender: ISenderInfo) => {
//         return sender.senderId;
//     });
// }

// function resolveSenderOrganisations(senderInfoList: ISenderInfo[], senderOrganisations: IOrganisation[]) {
//     return Promise.all(
//         senderInfoList.map<ISenderInfo>((senderInfo: ISenderInfo) => {
//             const senderOrg = senderOrganisations.find(
//                 (senderOrg: IOrganisation) => senderOrg.cvrNumber === senderInfo.senderId
//             );
//             return {
//                 id: senderOrg.id,
//                 senderId: senderInfo.senderId,
//                 senderIdType: senderInfo.senderIdType,
//                 messageCountList: senderInfo.messageCountList.map((messageCount: ISenderMessageCount) => {
//                     return {
//                         label: messageCount.label,
//                         unreadMessages: messageCount.unreadMessages,
//                         totalMessages: messageCount.totalMessages,
//                         latestMessageFrom: messageCount.latestMessageFrom,
//                     };
//                 }),
//                 name: senderOrg.name,
//                 logoMimeType: senderOrg.logoMediaType,
//                 logoAvailable: senderOrg.logoAvailable,
//                 imageUrl: null,
//             };
//         })
//     );
// }

async function resolveLogos(senderInfoList: ISenderInfo[]) {
    senderInfoList = await Promise.all(
        senderInfoList.map(async (senderInfo: ISenderInfo) => {
            return {
                id: senderInfo.id,
                senderId: senderInfo.senderId,
                organisationId: senderInfo.organisationId,
                senderIdType: senderInfo.senderIdType,
                messageCountList: senderInfo.messageCountList.map((messageCount: ISenderMessageCount) => {
                    return {
                        label: messageCount.label,
                        unreadMessages: messageCount.unreadMessages,
                        totalMessages: messageCount.totalMessages,
                        latestMessageFrom: messageCount.latestMessageFrom,
                    };
                }),
                name: senderInfo.name,
                logoMimeType: senderInfo.logoMimeType,
                logoAvailable: senderInfo.logoAvailable,
                imageUrl: null,
            };
        })
    );

    return senderInfoList;
}
